<template>
  <div class="text-xs-center">
    <v-dialog
      v-model="config.confirm"
      width="500"
    >
      <v-card>
        <v-card-title
          class="headline grey lighten-2"
          primary-title
        >
          {{config.confirmTitle}}
        </v-card-title>

        <v-card-text>
          {{config.confirmBody}}
        </v-card-text>

        <v-divider></v-divider>
        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="changeImage(1)">Yes</v-btn>&nbsp;&nbsp;&nbsp;
          <v-btn color="green darken-1" text @click="changeImage(0)">No</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  export default {
    props:['config', 'bgcolorx'],
    data () {
      return {
        dialog: false
      }
    },
    methods: {
        changeImage(result){
            this.config.confirmResult = result;
            this.config.confirm = false;
        }
    }
  }
</script>